module.exports = {"211404002":"沙锅屯街道","211404008":"九龙街道","211404010":"龙腾街道","211404101":"缸窑岭镇","211404102":"暖池塘镇","211404103":"高桥镇","211404104":"虹螺岘镇","211404105":"金星镇","211404106":"台集屯镇","211404201":"沙锅屯乡","211404203":"黄土坎乡","211404204":"大兴乡","211404205":"张相公屯乡","211404400":"乌金塘水库","211404401":"南票飞地经济区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211404.json
// module id = 687
// module chunks = 0